import * as PIXI from 'pixi.js';
import {SoundManager, StoryManager} from '@/systems';
import {dayConfigs} from "@/config/DayConfig";

export class VignetteEyeBlink {

  private container: PIXI.Container;
  private eyelidSprite: PIXI.Sprite;
  private darkSprite: PIXI.Sprite;

  private bpm:number = 2;
  private timer:number = 0;
  private isFalling:boolean = false;

  public setBPM(bpm:number){
    this.bpm = bpm
  }

  constructor(screenWidth: number, screenHeight: number) {
    this.initialization(screenWidth, screenHeight)
  }

  private async initialization(screenWidth: number, screenHeight: number){
    this.container = new PIXI.Container()

    try {
      // Load texture from path using PIXI.Assets.load (PIXI v8)
      // const vignetteTexture = await PIXI.Assets.load("/assets/misc/vignette_eye.png");
      const vignetteTexture = await PIXI.Assets.load("/assets/misc/vignet_eye_v2.png");
      const darkTexture = await PIXI.Assets.load("/assets/cutscene/black.ktx2");

      let eyelidSprite = new PIXI.Sprite(vignetteTexture)
      let darkSprite = new PIXI.Sprite(darkTexture)
      this.eyelidSprite = eyelidSprite
      this.darkSprite = darkSprite

      // Scale background to cover entire viewport (like CSS background-size: cover)
      const bgScaleX = screenWidth / vignetteTexture.width;
      const bgScaleY = screenHeight / vignetteTexture.height;

      eyelidSprite.width = screenWidth
      eyelidSprite.height = screenHeight
      eyelidSprite.alpha = 0

      darkSprite.width = screenWidth
      darkSprite.height = screenHeight
      darkSprite.alpha = 0

      this.container.visible  =true

      // sprite.scale.set(Math.max(bgScaleX, bgScaleY))
      this.container.addChild(eyelidSprite)
      this.container.addChild(darkSprite)

    } catch (error) {
      return PIXI.Texture.EMPTY;
    }

  }

  public getContainer() : PIXI.Container {
    return this.container
  }

  public startBlink(){
    this.timer = 0
    this.isFalling = true
    this.eyelidSprite.alpha = 1
  }

  public initializeAnimation(app) {

    app.ticker.add((ticker) => {
// Only run the math if the variable is true
      if (!this.isFalling) return;
      console.log("EPX", this.timer, this.darkSprite.alpha)

      this.timer += ticker.elapsedMS;
      const seconds = this.timer / 1000;

      if (seconds < 3) {
        this.darkSprite.alpha = 1;
      }
      else if (seconds < 6) {
        // Normalize 3s-6s to 0.0 - 1.0
        let progress = (seconds - 3) / 3;
        this.darkSprite.alpha = 1 - progress;
      }
      else if (seconds < 9) {
        // Blinking
        let blink = Math.abs(Math.cos((seconds - 6) * 2));
        this.darkSprite.alpha = blink;
      }
      else {
        // Sequence finished
        this.darkSprite.alpha = 0;
        this.isFalling = false; // Stop the calculation to save performance
        console.log("Sequence Finished!");
        this.eyelidSprite.alpha = 1
      }
    });

  }

  public stopAnimation(app){
    app.ticker.remove()
  }

  public destroy(): void {
    this.container.destroy();
  }
}
